import copy from 'copy-to-clipboard';

// Small wrapper to make potential replacement easier
const copyToClipboard = (text: string, options = {}) => {
  return copy(text, options);
};

export default copyToClipboard;
